// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-list-item__icon[data-v-18bd2760]{margin:12px 20px 12px 0!important}.v-tooltip__content.menuable__content__active[data-v-18bd2760]{opacity:1}", ""]);
// Exports
module.exports = exports;
